<template>
  <WorkspaceRoleDenied v-if="staffDenied" :area="t('workspaceFinanceiro.area')" />
  <div v-else class="workspace-financeiro-page">
    <div class="modern-header">
      <div class="header-container">
        <div class="breadcrumb-section">
          <nav class="breadcrumb">
            <button type="button" class="breadcrumb-item" @click="$router.push('/dashboard')">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
              </svg>
              {{ t('common.breadcrumb.dashboard') }}
            </button>
            <span class="breadcrumb-separator">/</span>
            <button type="button" class="breadcrumb-item" @click="$router.push(`/workspace/${workspaceId}`)">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
              </svg>
              {{ currentWorkspace?.nome || t('workspaceDashboard.defaultName') }}
            </button>
            <span class="breadcrumb-separator">/</span>
            <span class="breadcrumb-current">{{ t('workspaceFinanceiro.breadcrumbCurrent') }}</span>
          </nav>
        </div>

        <div class="title-section">
          <div class="title-content">
            <div class="title-icon" aria-hidden="true">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
            </div>
            <div class="title-text">
              <h1 class="main-title">{{ t('workspaceFinanceiro.title') }}</h1>
              <p class="subtitle">{{ t('workspaceFinanceiro.subtitle') }}</p>
            </div>
          </div>
          <div class="workspace-badge" :class="`type-${(currentWorkspace?.tipo || 'TAREFAS').toLowerCase()}`">
            <div class="badge-icon">
              <svg v-if="currentWorkspace?.tipo === 'CRM'" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
              </svg>
              <svg v-else class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"/>
              </svg>
            </div>
            <span class="badge-text">{{ currentWorkspace?.tipo || 'TAREFAS' }}</span>
          </div>
        </div>

        <div class="actions-section">
          <button type="button" class="action-button primary" @click="$router.push(`/workspace/${workspaceId}/kanban`)">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
            </svg>
            {{ t('workspaceFinanceiro.back') }}
          </button>
        </div>
      </div>
    </div>

    <div class="page-content">
      <section class="ws-fin-filters">
        <div class="ws-fin-filters__dates">
          <label class="ws-fin-filters__field">
            <span>{{ t('workspaceFinanceiro.filters.dateFrom') }}</span>
            <div class="ws-fin-filters__input-wrap">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
              </svg>
              <input v-model="filtros.periodoFinanceiroInicio" type="date" @change="carregar" />
            </div>
          </label>
          <label class="ws-fin-filters__field">
            <span>{{ t('workspaceFinanceiro.filters.dateTo') }}</span>
            <div class="ws-fin-filters__input-wrap">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
              </svg>
              <input v-model="filtros.periodoFinanceiroFim" type="date" @change="carregar" />
            </div>
          </label>
          <button type="button" class="ws-fin-filters__apply" :disabled="loading" @click="carregar">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
            </svg>
            {{ t('workspaceFinanceiro.filters.apply') }}
          </button>
        </div>
        <div class="ws-fin-filters__status">
          <span class="ws-fin-filters__status-label">{{ t('workspaceFinanceiro.filters.status') }}</span>
          <button
            v-for="opt in statusOptions"
            :key="opt.value"
            type="button"
            class="ws-fin-status-pill"
            :class="{
              'ws-fin-status-pill--active': filtros.financeiroStatus.includes(opt.value),
              [`ws-fin-status-pill--${opt.key}`]: true
            }"
            @click="toggleStatus(opt.value)"
          >
            <span class="ws-fin-status-pill__dot" />
            {{ opt.label }}
          </button>
        </div>
      </section>

      <div v-if="loading" class="ws-fin-state">
        <div class="ws-fin-spinner" />
        <p>{{ t('workspaceFinanceiro.loading') }}</p>
      </div>

      <div v-else-if="erro" class="ws-fin-state ws-fin-state--error">
        <p>{{ erro }}</p>
        <button type="button" class="ws-fin-filters__apply" @click="carregar">{{ t('workspaceFinanceiro.retry') }}</button>
      </div>

      <template v-else>
        <WorkspaceFinanceiroSummary :resumo="resumoFinanceiro" />

        <div v-if="!tasks.length" class="ws-fin-state">
          <div class="ws-fin-state__icon" aria-hidden="true">
            <svg width="28" height="28" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
          </div>
          <p>{{ t('workspaceFinanceiro.empty') }}</p>
        </div>

        <section v-else class="ws-fin-list-section">
          <div class="ws-fin-list-head">
            <h2 class="ws-fin-list-head__title">{{ t('workspaceFinanceiro.listTitle') }}</h2>
            <span class="ws-fin-list-head__count">{{ t('workspaceFinanceiro.listCount', { count: tasks.length }) }}</span>
          </div>
          <div class="ws-fin-table-head" aria-hidden="true">
            <span>{{ t('workspaceFinanceiro.columns.task') }}</span>
            <span>{{ t('workspaceFinanceiro.columns.open') }}</span>
            <span>{{ t('workspaceFinanceiro.columns.paid') }}</span>
            <span>{{ t('workspaceFinanceiro.columns.overdue') }}</span>
            <span />
          </div>
          <div class="ws-fin-list-body">
            <WorkspaceFinanceiroTaskRow
              v-for="task in tasks"
              :key="task.id"
              :task="task"
              @click="abrirTask(task)"
            />
          </div>
        </section>
      </template>
    </div>

    <TaskDetailModal
      v-if="showTask"
      :is-open="showTask"
      :task="selectedTask"
      @close="showTask = false"
      @taskUpdated="onTaskAtualizada"
    />
  </div>
</template>

<script setup>
import { computed, onMounted, reactive, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import api from '@/services/api'
import { useWorkspaceStore } from '@/stores/workspace'
import { useWorkspaceStaffGuard } from '@/composables/useWorkspaceStaffGuard'
import WorkspaceRoleDenied from '@/components/workspace/WorkspaceRoleDenied.vue'
import TaskDetailModal from '@/components/TaskDetailModal.vue'
import WorkspaceFinanceiroSummary from '@/components/workspace-financeiro/WorkspaceFinanceiroSummary.vue'
import WorkspaceFinanceiroTaskRow from '@/components/workspace-financeiro/WorkspaceFinanceiroTaskRow.vue'

const { t } = useI18n()
const route = useRoute()
const workspaceStore = useWorkspaceStore()
const currentWorkspace = computed(() => workspaceStore.currentWorkspace)
const { staffDenied, ensureAccess } = useWorkspaceStaffGuard(t('workspaceFinanceiro.area'))

const workspaceId = computed(() => route.params.id)
const loading = ref(false)
const erro = ref('')
const relatorio = ref({})
const showTask = ref(false)
const selectedTask = ref(null)

const toIsoDate = (d) => {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

const currentMonthRange = () => {
  const now = new Date()
  const start = new Date(now.getFullYear(), now.getMonth(), 1)
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 0)
  return { inicio: toIsoDate(start), fim: toIsoDate(end) }
}

const month = currentMonthRange()
const filtros = reactive({
  periodoFinanceiroInicio: month.inicio,
  periodoFinanceiroFim: month.fim,
  financeiroStatus: ['EM_ABERTO', 'VENCIDO', 'PAGO']
})

const statusOptions = computed(() => [
  { key: 'pending', value: 'EM_ABERTO', label: t('workspaceFinanceiro.status.pending') },
  { key: 'overdue', value: 'VENCIDO', label: t('workspaceFinanceiro.status.overdue') },
  { key: 'paid', value: 'PAGO', label: t('workspaceFinanceiro.status.paid') }
])

const resumoFinanceiro = computed(() => relatorio.value?.resumoFinanceiro || {})
const tasks = computed(() => relatorio.value?.tasks || [])

const toggleStatus = (value) => {
  const idx = filtros.financeiroStatus.indexOf(value)
  if (idx >= 0) {
    if (filtros.financeiroStatus.length > 1) {
      filtros.financeiroStatus.splice(idx, 1)
    }
  } else {
    filtros.financeiroStatus.push(value)
  }
  carregar()
}

const montarPayload = () => ({
  financeiroStatus: [...filtros.financeiroStatus],
  periodoFinanceiroInicio: filtros.periodoFinanceiroInicio || null,
  periodoFinanceiroFim: filtros.periodoFinanceiroFim || null,
  page: 0,
  size: 200
})

const carregar = async () => {
  if (staffDenied.value) return
  loading.value = true
  erro.value = ''
  try {
    const res = await api.post(
      `/tasks/workspace/${workspaceId.value}/relatorio-analitico`,
      montarPayload()
    )
    relatorio.value = res.data || {}
  } catch (e) {
    erro.value = e.response?.data?.error || e.message || t('workspaceFinanceiro.errors.load')
    relatorio.value = {}
  } finally {
    loading.value = false
  }
}

const abrirTask = async (row) => {
  if (!row?.id) return
  try {
    const r = await api.get(`/tasks/${row.id}`)
    selectedTask.value = r.data
    showTask.value = true
  } catch {
    erro.value = t('workspaceFinanceiro.errors.openTask')
  }
}

const onTaskAtualizada = () => {
  showTask.value = false
  carregar()
}

onMounted(async () => {
  await ensureAccess(workspaceId.value)
  if (staffDenied.value) return
  await workspaceStore.loadWorkspace(workspaceId.value)
  await carregar()
})

watch(workspaceId, async () => {
  await ensureAccess(workspaceId.value)
  if (staffDenied.value) return
  const m = currentMonthRange()
  filtros.periodoFinanceiroInicio = m.inicio
  filtros.periodoFinanceiroFim = m.fim
  await workspaceStore.loadWorkspace(workspaceId.value)
  await carregar()
})
</script>

<style src="@/assets/styles/workspace-financeiro.css"></style>
